import * as React from 'react';
import { useState } from 'react';
import Dashboard from '../models/Dashboard';
import { PaginatedContext, ContextValue } from '../components/management/pagination/paginated-context';
import { DashboardSortingOptions } from '../models/enums/adminSortingOptions';

const defaultState: PaginatedContext<Dashboard> = {
  loading: false,
  results: [],
  currentPage: 1,
  totalResults: 0,
  pageSize: 60,
  orderColumn: DashboardSortingOptions.Name,
  orderDirection: DashboardSortingOptions.Ascending,
  searchTerm: null
};

/** Context for sharing dashboard results to be displayed in a paginated form */
const PaginatedDashboardContext = React.createContext<ContextValue<Dashboard>>(null);

const PaginatedDashboardConsumer = PaginatedDashboardContext.Consumer;

const PagedDashboardProvider = props => {
  const [state, setState] = useState<PaginatedContext<Dashboard>>(defaultState);

  const dispatch = (newValue: any) => {
    setState(prevState => {
      return { ...prevState, ...newValue };
    });
  };

  return (
    <PaginatedDashboardContext.Provider value={{ ...state, dispatch }}>
      {props.children}
    </PaginatedDashboardContext.Provider>
  );
};

export { PaginatedDashboardContext, PagedDashboardProvider, PaginatedDashboardConsumer };
